(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["detropolis-entry"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('detropolis-entry')) {
 customElements.define('detropolis-entry', class extends HTMLElement {
  connectedCallback() {
   this.events?.abort();
   this.events = new AbortController();
   this.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dt-choice]');
    if (!button || !this.contains(button)) return;
    this.querySelectorAll('[data-dt-choice]').forEach(choice => choice.setAttribute('aria-pressed',String(choice === button)));
    this.dataset.selectedRoute = button.dataset.dtChoice;
    this.querySelector('.dt-entry__status').textContent = this.dataset.selectionLabel + ' ' + button.dataset.title;
    this.dispatchEvent(new CustomEvent('detropolis:entry-selected',{bubbles:true,composed:true,detail:{route:button.dataset.dtChoice,sectionId:this.id}}));
   },{signal:this.events.signal});
   const header = this.querySelector('.dt-entry__header');
   const footer = this.querySelector('.dt-entry__footer');
   const scenes = [...this.querySelectorAll('.dt-entry__scene')];
   const probe = this.querySelector('.dt-entry__viewport-probe');
   const setValue = (node, name, value) => {
    if (node.style.getPropertyValue(name) !== value) node.style.setProperty(name,value);
   };
   const measure = () => {
    cancelAnimationFrame(this.measureFrame);
    this.measureFrame = requestAnimationFrame(() => {
     if (!this.isConnected || this.inert || !this.getClientRects().length || !scenes.length) return;
     const adaptive = this.classList.contains('dt-entry--adaptive');
     const stacked = matchMedia('(max-width:1100px)').matches;
     const styles = getComputedStyle(this);
     const px = (name, fallback = 0) => parseFloat(styles.getPropertyValue(name)) || fallback;
     const width = this.clientWidth;
     const viewport = probe.getBoundingClientRect().height || window.innerHeight;
     const pageTop = Math.max(0,this.getBoundingClientRect().top + window.scrollY);
     const footerHeight = footer.getBoundingClientRect().height;
     const headerHeight = header.getBoundingClientRect().height;
     const configured = px('--dt-height',680);
     const manualReference = px('--dt-scene-reference');
     const fluidReference = stacked ? width < 750 ? Math.min(680,Math.max(460,width * 1.25)) : Math.min(840,Math.max(600,width * .8)) : configured;
     const reference = manualReference || (adaptive ? Math.max(configured,fluidReference) : configured);
     const sceneMeasurements = scenes.map(scene => {
      const copy = scene.querySelector('.dt-entry__copy');
      const copyBox = copy.getBoundingClientRect();
      const contentBoxes = [copyBox,...[...copy.children].map(node => node.getBoundingClientRect())];
      const top = Math.min(...contentBoxes.map(box => box.top));
      const bottom = Math.max(...contentBoxes.map(box => box.bottom));
      const copyBottom = parseFloat(getComputedStyle(copy).bottom) || 0;
      const textRoom = bottom - top + Math.max(0,copyBottom) + Math.max(0,bottom - copyBox.bottom);
      const headerRoom = !stacked || scene.dataset.route === 'west' ? headerHeight : 0;
      const diagonalRoom = stacked && scene.dataset.route === 'detroit' ? px('--dt-slope') : 0;
      const minimum = Math.ceil(Math.max(headerRoom,diagonalRoom) + textRoom + 180);
      const ownReference = stacked ? px('--dt-' + scene.dataset.route + '-min',reference) : reference;
      return {scene,minimum,reference:ownReference};
     });
     const minimum = Math.max(...sceneMeasurements.map(item => item.minimum));
     const available = Math.max(0,viewport - pageTop - footerHeight);
     const fitted = Math.ceil(Math.max(minimum,available));
     setValue(this,'--dt-header-room',Math.ceil(headerHeight) + 'px');
     setValue(this,'--dt-auto-min',minimum + 'px');
     if (adaptive) {
      setValue(this,'--dt-fit-height',fitted + 'px');
      const west = sceneMeasurements.find(item => item.scene.dataset.route === 'west');
      const westHeight = west ? Math.max(west.minimum,Math.min(west.reference,Math.max(west.reference * .85,available * .75))) : reference;
      const headerScale = stacked ? westHeight / (west?.reference || reference) : fitted / reference;
      setValue(this,'--dt-scale',Math.min(1.18,Math.max(.8,headerScale)).toFixed(4));
     }
     sceneMeasurements.forEach(item => {
      const route = item.scene.dataset.route;
      setValue(this,'--dt-' + route + '-auto-min',item.minimum + 'px');
      if (!adaptive) return;
      const target = stacked ? Math.ceil(Math.max(item.minimum,Math.min(item.reference,Math.max(item.reference * .85,available * .75)))) : fitted;
      setValue(this,'--dt-' + route + '-fit-height',target + 'px');
      setValue(item.scene,'--dt-scene-scale',Math.min(1.18,Math.max(.8,target / item.reference)).toFixed(4));
     });
    });
   };
   this.observer?.disconnect();
   if ('ResizeObserver' in window) {
    this.observer = new ResizeObserver(measure);
    [this,header,footer,probe,...this.querySelectorAll('.dt-entry__copy')].forEach(node => this.observer.observe(node));
   }
   window.addEventListener('resize',measure,{signal:this.events.signal,passive:true});
   const signal = this.events.signal;
   document.fonts?.ready.then(() => { if (!signal.aborted) measure(); });
   measure();
  }
  disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.measureFrame); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["detropolis-new-edition-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('detropolis-street-hero')) {
  customElements.define('detropolis-street-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.dshConnected) return;
      this.dshConnected = true;
      this.dshAnimations = new WeakMap();
      this.dshTargets = new WeakMap();
      this.querySelectorAll('.dsh__detail').forEach((detail) => {
        detail.removeAttribute('name');
      });
      this.addEventListener('click', (event) => {
        const summary = event.target.closest('.dsh__option');
        if (!summary || !this.contains(summary)) return;
        const detail = summary.parentElement;
        event.preventDefault();
        const target = this.dshTargets.has(detail) ? this.dshTargets.get(detail) : detail.open;
        if (!target) {
          this.querySelectorAll('.dsh__detail').forEach((other) => {
            if (other !== detail && (other.open || this.dshTargets.get(other))) this.dshSetExpanded(other, false);
          });
        }
        this.dshSetExpanded(detail, !target);
      });
    }
    dshSetExpanded(detail, expanded) {
      const start = detail.getBoundingClientRect().height;
      const running = this.dshAnimations.get(detail);
      if (running) running.cancel();
      this.dshTargets.set(detail, expanded);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || typeof detail.animate !== 'function') {
        detail.open = expanded;
        detail.style.overflow = '';
        this.dshTargets.delete(detail);
        this.dshAnimations.delete(detail);
        return;
      }
      if (expanded) detail.open = true;
      const style = getComputedStyle(detail);
      const borders = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const end = expanded ? detail.getBoundingClientRect().height : detail.querySelector('summary').getBoundingClientRect().height + borders;
      detail.style.overflow = 'hidden';
      const animation = detail.animate([{ height: `${start}px` }, { height: `${end}px` }], {
        duration: 240,
        easing: 'cubic-bezier(.2,.7,.2,1)'
      });
      this.dshAnimations.set(detail, animation);
      animation.onfinish = () => {
        if (this.dshAnimations.get(detail) !== animation) return;
        detail.open = expanded;
        detail.style.overflow = '';
        this.dshAnimations.delete(detail);
        this.dshTargets.delete(detail);
      };
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
